// @ts-nocheck
import { Nullable, Project, ProjectUtils, TFile, ImageSizeRequest } from '@brg/api';
import { ComputedTag, computeTag } from './ComputedTag';
import imgSrc from '../../../assets/project.svg';
import { ComputedTeam, computeTeam } from './ComputedTeam';
import { ComputedPoint, computePoint } from './ComputedPoint';
import { ComputedDesigner, computeDesigner } from '../../computeData';
import { ImageRequest } from '../../../constants/imageRequest';
import { isLowMode } from '../../lowmode';
import {executeTypograf} from "../../../utils/executeTypograf";

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 */
export interface ComputedProject {
    title: string;
    projectId: string;
    projectType: string;
    /**
      * @deprecated The field should not be used
      */
    authors: ComputedDesigner[];
    author: ComputedDesigner | undefined;
    coAuthors: ComputedDesigner[];
    /**
     * @deprecated The field should not be used
     */
    authorIds: string[];
    authorId: string;
    coAuthorIds: string[];
    curators: ComputedDesigner[];
    curatorsIdList: string[];
    creatorId: string;
    creator: ComputedDesigner | undefined;
    category: ComputedTag;
    competitionId: string | undefined;
    team: ComputedTeam;
    image: string;
    titleImages?: TFile[];
    titleImages_en?: TFile[];
    tags: ComputedTag[];
    tagsID?: string[];
    point: ComputedPoint;
    projectType: string,
    identifier: string;
    status: number;
    likes: number;
    quPersonCount: number;
    has: boolean;
    isLiked: boolean;
    isBookPublished: boolean;
    isBook: boolean;
    originalImageInfo: {
        width: number,
        height: number,
        quality: number,
    }
    originalImageInfoEn: {
        width: number,
        height: number,
        quality: number,
    },
    friendlyURLPath: string
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 * Здесь есть аргумент imageSize - он отвечает за резоляцию изображений
 *
 * @param project
 * @param imageSize
 */
export function computeProject(project: Nullable<Partial<Project>>, imageSize?: ImageSizeRequest, twoGridSection?: boolean): ComputedProject {
    const image = ProjectUtils.getTitleImageOrUndefined(project, isLowMode() ? 'qvga' : imageSize ?? ImageRequest.tile);

    return {
        projectId: project?.projectId ?? 'undefined',
        additionalInfo: project?.additionalInfo ?? {},
        identifier: project?.projectId ?? 'undefined',
        status: project?.status ?? 0,
        title: executeTypograf(project?.title ?? 'untitled'),
        authors: project?.authors ? project.authors.map(computeDesigner) : [],
        author: project?.author ? computeDesigner(project?.author) : undefined,
        authorGlobalTypes: project?.authorGlobalTypes,
        coAuthors: project?.coAuthors ? project.coAuthors.map(computeDesigner) : [],
        curators: project?.curators ? project.curators.map(computeDesigner) : [],
        additionalInfo: project?.additionalInfo ? project.additionalInfo : [],
        curatorsIdList: project?.curatorsIdList ? project.curatorsIdList : [],
        isAdaptiveCard: project?.isAdaptiveCard ? project?.isAdaptiveCard : false,
        authorIds: project?.authorIds ? project.authorIds : [],
        authorId: project?.authorId ? project.authorId : "",
        coAuthorIds: project?.coAuthorIds ? project.coAuthorIds : [],
        creatorId: project?.creatorId ? project.creatorId : "",
        projectContexts: project?.contexts ? project.contexts : [],
        created: project?.created ? project.created : undefined,
        competitionId: project?.competitionId ? project?.competitionId : undefined,
        //@ts-ignore
        competitionIds: project?.competitionApproves ? project?.competitionApproves?.map(({ competitionId }) => competitionId) : [],
        //@ts-ignore
        paymentType: project?.paymentType || 0,
        //@ts-ignore
        competitionApproves: project?.competitionApproves ? project?.competitionApproves : [],
        //@ts-ignore
        canEdit_PartCompetition: !!project?.canEdit_PartCompetition,
        creator: project?.creator ? computeDesigner(project?.creator) : undefined,
        category: computeTag(project?.category),
        image: image ?? imgSrc,
        titleImages: project?.titleImages,
        //@ts-ignore
        isAgeRestricted: project?.isAgeRestricted,
        titleImages_en: project?.titleImages_en,
        team: computeTeam(project?.team),
        tags: project?.tags ? project.tags.map(computeTag) : [],
        tagsID: project?.tagsID,
        point: computePoint(project?.point),
        projectType: project?.projectType,
        isPresentation: project?.contexts?.includes('propresentation'),
        quPersonCount: project?.quPersonCount ?? project?.quCount ?? 0,
        likes: project?.quPersonCount ?? project?.quCount ?? 0,
        isLiked: project?.isQu ?? false,
        isBookmark: project?.isBookmark,
        isBilingual: project?.isBilingual,
        has: !!project,
        book: project?.book,
        bookId: project?.bookId,
        isBookPublished: project?.isBookPublished ?? false,
        isBook: project?.isBook ?? false,
        projectType: project?.projectType ?? '',
        originalImageInfo: project?.originalImageInfo ?? {
            width: 0,
            height: 0,
            quality: 0
        },
        originalImageInfoEn: project?.originalImageInfoEn ?? {
            width: 0,
            height: 0,
            quality: 0
        },
        friendlyURLPath: project?.friendlyURLPath
    };
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 * @param project
 */
export function computeProjectMapTile(project?: Nullable<Partial<Project>>): ComputedProject {
    return computeProject(project);
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 * @param project
 */
export function computeProjectMapImage(project?: Nullable<Partial<Project>>): ComputedProject {
    return computeProject(project, ImageRequest.image);
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 * @param projects
 * @param imageSize
 */
export function computeManyProjects(
    projects: Nullable<Nullable<Partial<Project>>[]>,
    imageSize?: ImageSizeRequest,
): ComputedProject[] {
    return projects ? projects.map((v) => computeProject(v, imageSize)) : [];
}
// @ts-nocheck
import { Nullable, Project, ProjectUtils, TFile, ImageSizeRequest } from '@brg/api';
import { ComputedTag, computeTag } from './ComputedTag';
import imgSrc from '../../../assets/project.svg';
import { ComputedTeam, computeTeam } from './ComputedTeam';
import { ComputedPoint, computePoint } from './ComputedPoint';
import { ComputedDesigner, computeDesigner } from '../../computeData';
import { ImageRequest } from '../../../constants/imageRequest';
import { isLowMode } from '../../lowmode';
import {executeTypograf} from "../../../utils/executeTypograf";

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 */
export interface ComputedProject {
    title: string;
    projectId: string;
    projectType: string;
    /**
      * @deprecated The field should not be used
      */
    authors: ComputedDesigner[];
    author: ComputedDesigner | undefined;
    coAuthors: ComputedDesigner[];
    /**
     * @deprecated The field should not be used
     */
    authorIds: string[];
    authorId: string;
    coAuthorIds: string[];
    curators: ComputedDesigner[];
    curatorsIdList: string[];
    creatorId: string;
    creator: ComputedDesigner | undefined;
    category: ComputedTag;
    competitionId: string | undefined;
    team: ComputedTeam;
    image: string;
    titleImages?: TFile[];
    titleImages_en?: TFile[];
    tags: ComputedTag[];
    tagsID?: string[];
    point: ComputedPoint;
    projectType: string,
    identifier: string;
    status: number;
    likes: number;
    quPersonCount: number;
    has: boolean;
    isLiked: boolean;
    isBookPublished: boolean;
    isBook: boolean;
    originalImageInfo: {
        width: number,
        height: number,
        quality: number,
    }
    originalImageInfoEn: {
        width: number,
        height: number,
        quality: number,
    },
    friendlyURLPath: string
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 * Здесь есть аргумент imageSize - он отвечает за резоляцию изображений
 *
 * @param project
 * @param imageSize
 */
export function computeProject(project: Nullable<Partial<Project>>, imageSize?: ImageSizeRequest, twoGridSection?: boolean): ComputedProject {
    const image = ProjectUtils.getTitleImageOrUndefined(project, isLowMode() ? 'qvga' : imageSize ?? ImageRequest.tile);

    return {
        projectId: project?.projectId ?? 'undefined',
        additionalInfo: project?.additionalInfo ?? {},
        identifier: project?.projectId ?? 'undefined',
        status: project?.status ?? 0,
        title: executeTypograf(project?.title ?? 'untitled'),
        authors: project?.authors ? project.authors.map(computeDesigner) : [],
        author: project?.author ? computeDesigner(project?.author) : undefined,
        authorGlobalTypes: project?.authorGlobalTypes,
        coAuthors: project?.coAuthors ? project.coAuthors.map(computeDesigner) : [],
        curators: project?.curators ? project.curators.map(computeDesigner) : [],
        additionalInfo: project?.additionalInfo ? project.additionalInfo : [],
        curatorsIdList: project?.curatorsIdList ? project.curatorsIdList : [],
        isAdaptiveCard: project?.isAdaptiveCard ? project?.isAdaptiveCard : false,
        authorIds: project?.authorIds ? project.authorIds : [],
        authorId: project?.authorId ? project.authorId : "",
        coAuthorIds: project?.coAuthorIds ? project.coAuthorIds : [],
        creatorId: project?.creatorId ? project.creatorId : "",
        projectContexts: project?.contexts ? project.contexts : [],
        created: project?.created ? project.created : undefined,
        competitionId: project?.competitionId ? project?.competitionId : undefined,
        //@ts-ignore
        competitionIds: project?.competitionApproves ? project?.competitionApproves?.map(({ competitionId }) => competitionId) : [],
        //@ts-ignore
        paymentType: project?.paymentType || 0,
        //@ts-ignore
        competitionApproves: project?.competitionApproves ? project?.competitionApproves : [],
        //@ts-ignore
        canEdit_PartCompetition: !!project?.canEdit_PartCompetition,
        creator: project?.creator ? computeDesigner(project?.creator) : undefined,
        category: computeTag(project?.category),
        image: image ?? imgSrc,
        titleImages: project?.titleImages,
        //@ts-ignore
        isAgeRestricted: project?.isAgeRestricted,
        titleImages_en: project?.titleImages_en,
        team: computeTeam(project?.team),
        tags: project?.tags ? project.tags.map(computeTag) : [],
        tagsID: project?.tagsID,
        point: computePoint(project?.point),
        projectType: project?.projectType,
        isPresentation: project?.contexts?.includes('propresentation'),
        quPersonCount: project?.quPersonCount ?? project?.quCount ?? 0,
        likes: project?.quPersonCount ?? project?.quCount ?? 0,
        isLiked: project?.isQu ?? false,
        isBookmark: project?.isBookmark,
        isBilingual: project?.isBilingual,
        has: !!project,
        book: project?.book,
        bookId: project?.bookId,
        isBookPublished: project?.isBookPublished ?? false,
        isBook: project?.isBook ?? false,
        projectType: project?.projectType ?? '',
        originalImageInfo: project?.originalImageInfo ?? {
            width: 0,
            height: 0,
            quality: 0
        },
        originalImageInfoEn: project?.originalImageInfoEn ?? {
            width: 0,
            height: 0,
            quality: 0
        },
        friendlyURLPath: project?.friendlyURLPath
    };
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 * @param project
 */
export function computeProjectMapTile(project?: Nullable<Partial<Project>>): ComputedProject {
    return computeProject(project);
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 * @param project
 */
export function computeProjectMapImage(project?: Nullable<Partial<Project>>): ComputedProject {
    return computeProject(project, ImageRequest.image);
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 * @param projects
 * @param imageSize
 */
export function computeManyProjects(
    projects: Nullable<Nullable<Partial<Project>>[]>,
    imageSize?: ImageSizeRequest,
): ComputedProject[] {
    return projects ? projects.map((v) => computeProject(v, imageSize)) : [];
}
